jQuery(document).ready(function($) {
    $('form#big_login').submit(function(e) {
        e.preventDefault();

        let formParent = $(this).parent();
        formParent.addClass('loading');

        $.post($(this).data('url'), {
            action: $(this).attr('action'),
            data: $(this).serialize(),
            dataType: 'json',
        }, function(data) {
            if(typeof data.data != 'undefined') {
                window.location.replace(data.data.redirect);
            }
        }).fail(function(data) {
            //Reset inputs
            formParent.find('.is-invalid').removeClass('is-invalid');
            formParent.find('.invalid-feedback').remove();

            $.each(data.responseJSON.data.errors, function(field_name, error) {
                formParent.find('[name='+field_name+']').first().parent().addClass('is-invalid').append(
                    "<div class='invalid-feedback'>"+error+"</div>"
                );
            });
        }).always(function() {
            formParent.removeClass('loading');
        });
    });
});